import { render, staticRenderFns } from "./inspectsFile.vue?vue&type=template&id=78965bc4&scoped=true&"
import script from "./inspectsFile.vue?vue&type=script&lang=js&"
export * from "./inspectsFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78965bc4",
  null
  
)

export default component.exports